module.exports = __webpack_public_path__ + "static/media/16.086c58e7.png";